<template>
  <v-dialog
    v-model="show"
    max-width="500"
    persistent
    @click:outside="clickOutside"
  >
    <v-card
      class="max-width scroll-hidden rounded-lg fill-height"
      :color="backgroundColor"
    >
      <v-row class="max-width">
        <v-col
          class="d-flex justify-center pa-0"
          align="center"
          justify="center"
          :cols="3"
        >
          <v-icon class="pl-2" :color="iconColor" size="80px">
            {{ icon }}
          </v-icon>
        </v-col>
        <v-col :cols="9" class="pl-0">
          <v-card-title style="word-break: break-word" class="pl-0">
            <v-col :cols="10">{{ title }}</v-col>
            <v-col :cols="2" class="text-right">
              <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-card-title>
          <v-card-text class="text-body-1 pl-2">{{ text }}</v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
>>> .v-dialog {
  overflow-y: visible;
}

.scroll-hidden {
  overflow-y: hidden;
  overflow-x: hidden;
}

.max-width {
  max-width: 500px !important;
  min-width: 500px !important;
}
</style>

<script>
export default {
  name: 'Popup',
  props: {
    type: {
      type: String,
      default: 'info',
      validator(t) {
        return ['success', 'warning', 'error', 'info'].includes(t);
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'info':
          return 'mdi-information';
        case 'success':
          return 'mdi-check-circle';
        case 'warning':
          return 'mdi-alert';
        case 'error':
          return 'mdi-alert-circle';
        default:
          return 'mdi-information';
      }
    },
    iconColor() {
      switch (this.type) {
        case 'info':
          return '#727272';
        case 'success':
          return '#00bfa5';
        case 'warning':
          return '#ffac1e';
        case 'error':
          return '#ff5252';
        default:
          return '#727272';
      }
    },
    backgroundColor() {
      switch (this.type) {
        case 'info':
          return '#f7f7f7';
        case 'success':
          return '#a8f0c6';
        case 'warning':
          return '#ffd48a';
        case 'error':
          return '#f7a7a3';
        default:
          return '#f7f7f7';
      }
    },
  },
  methods: {
    clickOutside() {
      if (!this.persistent) this.$emit('close');
    },
  },
};
</script>
